<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      align="start"
      class="fill-height ma-0"
    >
      <v-col
        cols="12"
      >
        <span class="subtitle-1">O cartão de crédito utilizado neste pagamento:</span>
      </v-col>

      <v-col
        cols="12"
      >
        <v-row
          align="center"
          class="ma-0"
        >
          <div :class="['mr-2',creditCardBrandLogo]"></div>
          <span class="subtitle-2 mr-2"><b>{{creditCardLastDigits}}</b></span>
          <span class="caption">últimos 4 digitos</span>
        </v-row>
      </v-col>

      <v-col
        cols="12"
      >
        <span class="subtitle-1" v-html="infoText"></span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from "vuex"
  import {GET_POST_PAYMENT_DATA} from "../../store/modules/post-payment"
  import {TRANSACTION_TYPE} from "../../helpers/transactions/constants"
  import {CREDIT_CARD_LOGO} from "../../helpers/payment/constants"

  export default {
    name: "CreditCardMainInfo",
    computed: {
      creditCardLastDigits() {
        if (!this.postPaymentData) return ""
        return this.postPaymentData["cardData"]["creditCardLastDigits"]
      },
      creditCardBrandLogo() {
        if (!this.postPaymentData) return "card-logo small unknown"
        return CREDIT_CARD_LOGO[this.postPaymentData["cardData"]["creditCardBrand"]] || "card-logo small unknown"
      },
      infoText() {
        if (!this.postPaymentData) return ""

        let infoText = ""
        switch (this.postPaymentData["transaction"]["ab_transaction_type"]) {
          case TRANSACTION_TYPE.IMAGE_PROCESSING:
            infoText = "Após a aprovação do pagamento pela sua operadora de cartão de crédito, seu processamento começará automaticamente."
            break
          case TRANSACTION_TYPE.SUBSCRIPTION:
          case TRANSACTION_TYPE.SUBSCRIPTION_UPDATE:
            infoText = "Após a aprovação do pagamento pela sua operadora de cartão de crédito, sua assinatura estará ativa."
            break
          case TRANSACTION_TYPE.POST_PROCESSING:
            infoText = "Após a aprovação do pagamento pela sua operadora de cartão de crédito, a análise agronômica será realizada."
            break
          case TRANSACTION_TYPE.PHYSICAL_PRODUCT:
            infoText = "Após aprovação do pagamento pela sua operadora de cartão de crédito, você receberá por e-mail a confirmação de inscrição na Turma Phantom."
            break
          default:
            break
        }
        return infoText
      },
      ...mapGetters({
        postPaymentData: GET_POST_PAYMENT_DATA,
      }),
    },
  }
</script>

<style scoped>

</style>
